<template>
    <div class="background" v-if="$gameData.images.background"></div>
</template>

<script>
    export default {
        data() {
            return {
                image: '',
                st: null,
                interval: 2000,
                userData: this.$userData,
            }
        },

        watch: {
            ages(val) {
                if (val) {
                    this.setBackground()
                }
            },
            age(val) {
                if (val) {
                    this.setBackground()
                }
            },
        },
        computed: {
            ages() {
                return this.$gameData.ages
            },
            age() {
                let age

                if (!this.ages || !this.ages.length) return

                this.ages.forEach(item => {
                    if (item.ages === this.$userData.age) {
                        age = item
                    }
                })

                return age
            },
            template() {
                return this.$gameData.images.background[this.age.ages]
            },
            sequence() {
                return this.$userData.sequence
            },

            position() {
                let left

                if (!this.age) return

                this.age.items.forEach(item => {
                    if (item.sequence === this.sequence) {
                        left = item.left
                    }
                })

                if (left >= this.template.width - 954) {
                    left = this.template.width - 954
                }

                return left
            }
        },
        beforeDestroy() {
            if (this.st) {
                clearTimeout(this.st)
                this.st = null
            }

            this.$eventBus.$off('START_MOVING')
            this.$eventBus.$off('CHANGE_AGE')
            this.$eventBus.$off('START_ENDING')
            $('.background').stop()
        },
        mounted() {
            if (this.age) {
                this.setBackground()
            }

            this.$eventBus.$on('START_MOVING', this.startMoving)

            this.$eventBus.$on('CHANGE_AGE', _ => {
                if (this.st) {
                    clearTimeout(this.st)
                    this.st = null
                }

                if (this.$userData.age !== 70) {
                    setTimeout(_ => {
                        $('.background').stop().css('background-position-x', 0)
                    }, 1000)
                }
            })

            this.$eventBus.$on('START_ENDING', _ => {

                if (!this.age) return

                let pos = Math.min(this.template.width - 954, this.position + 1000);

                const position = -1 * pos
                $('.background').stop().animate({
                    'background-position-x': position
                }, 5000, 'linear')
            })
        },
        methods: {
            setBackground() {
                if (!this.age) return

                this.image = this.template.url
                $('.background').css('background-image', `url(${this.image})`)
                if (this.$userData.sequence > 1)  {
                    this.$userData.sequence--
                    $('.background').css('background-position-x', -1 * this.position)
                    this.$userData.sequence++
                } else {
                    $('.background').css('background-position-x', 0)
                }
            },

            startMoving() {

                if (!this.age) return

                const interval = this.interval + ((this.$userData.testAge || this.$userData.age) - 20) * 20

                if (this.image !== this.template.url) {
                    this.setBackground()
                }

                const currentPosition = parseInt($('.background').css('background-position-x').replace('px'))
                const nextPosition = -1 * this.position

                this.$eventBus.$emit('MOVE_SPOUSE', nextPosition - currentPosition, interval)

                $('.background').stop().animate({
                    'background-position-x': nextPosition
                }, interval, 'linear')

                if (this.st) {
                    clearTimeout(this.st)
                    this.st = null
                }

                this.st = setTimeout(_ => {
                    this.$eventBus.$emit('ANIMATION_ENDED')
                }, interval)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .background {
        width: 100%;
        height: 100%;
        background-position: 0 0;
    }

</style>
